<template>
    <section>
        <div class="gmp-section gmp-mb-l">
            <div class="color-bar">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-l--8 h-c-grid__col-l--offset-2 h-c-grid__col--align-middle">
                            <div class="color-bar__icon color-bar__icon--green "></div>
                            <h3 class="h-c-headline h-c-headline--two color-bar__quote">
                                <span>我们采购部员工和所有门店订货使用</span>
                                <span class="color-bar__highlight color-bar__highlight--green">
                                    微信小程序工作
                                </span>

                                <span> 后, 工作轻松多了，向供货商订货也非常方便.</span>

                            </h3>
                            <p class="color-bar__credit">
                                <span class="color-bar__author">江户前寿司 采购部经理</span>
                                <span> 刘子银</span>
                            </p>
                        </div>
                    </div>

                </div>

            </div>
        </div>

    </section>
</template>

<script>
    export default {
        name: "HomeColorBar"
    }
</script>

<style lang="less">


</style>